import React from 'react'
import Box from '../Box'

export default function Divider(props: any) {
  return <Box height="xxsmall" bg="background.3" {...props} />
}
